<template>
  <b-container fluid>
    <div class="row">
      <div class="col-lg lizard-form-empty-col"></div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-center">
        <FitersBar />
      </div>
    </div>
    <div class="row" v-if="listItems.length">
      <div class="col-sm-12">
        <b-table
          caption-top
          responsive
          fixed
          striped
          small
          borderless
          table-class="lizard-activity-list lizard-expenses-box"
          thead-class="label"
          tbody-class="value"
          variant="secondary"
          :items="listItems"
          :fields="listFields"
          :per-page="pager.perPage"
          :current-page="pager.currentPage">
          <template #table-caption
            >Requests (You can view and update allowance summaries by clicking
            on names.)</template
          >
          <template #cell(submitted)="data">
            {{ formatDate(data.item.submitted) }}
          </template>
          <template #cell(fullname)="data">
            <b-link @click="showLeaveStats(data.item.owner)">
              {{ data.item.owner.firstName }}
              {{ data.item.owner.lastName }}
            </b-link>
          </template>
          <template #cell(type)="data">
            <span
              v-if="data.item.typeOnEdit"
              @click="data.item.typeOnEdit = false">
              <b-form-select
                v-if="data.item.holidayTypes.length"
                id="type"
                size="sm"
                v-model="data.item.type"
                :disabled="!data.item.holidayTypes.length"
                :options="data.item.holidayTypes"
                @change="changeHolidayType(data.item)"
                required>
                <template #first>
                  <b-form-select-option :value="null" disabled
                    >Select a Holiday type</b-form-select-option
                  >
                </template>
              </b-form-select>
              <div class="d-flex justify-content-center mb-3" v-else>
                <b-button size="sm" variant="light" disabled>
                  <b-spinner small type="grow" label="Loading..."></b-spinner>
                  &nbsp;<strong style="color: #666"
                    >Loading Leave Types...</strong
                  >
                </b-button>
              </div>
            </span>
            <span
              v-else
              @click="getHolidayTypeList(data.item)"
              style="cursor: pointer"
              v-b-tooltip.hover.bottom="{ variant: 'dark' }"
              title="Click to modify"
              >{{ data.item.type }}</span
            >
          </template>
          <template #cell(startDate)="data">
            <span
              v-if="data.item.datesOnEdit.includes('startDate')"
              style="cursor: pointer">
              <el-date-picker
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                format="dd/MM/yyyy"
                :clearable="false"
                v-model="data.item.startDate"
                :picker-options="datePickerOptions"
                @blur="
                  toggleModifyDate(data.item, 'startDate')
                "></el-date-picker>
            </span>
            <span
              v-else
              v-b-tooltip.hover.bottom="{ variant: 'dark' }"
              title="Click to modify"
              @click="toggleModifyDate(data.item, 'startDate')"
              style="cursor: pointer"
              >{{ formatDate(data.item.startDate) }}</span
            >
          </template>
          <template #cell(endDate)="data">
            <span
              v-if="data.item.datesOnEdit.includes('endDate')"
              style="cursor: pointer">
              <el-date-picker
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                format="dd/MM/yyyy"
                :clearable="false"
                v-model="data.item.endDate"
                :picker-options="datePickerOptions"
                @blur="toggleModifyDate(data.item, 'endDate')"></el-date-picker>
            </span>
            <span
              v-else
              v-b-tooltip.hover.bottom="{ variant: 'dark' }"
              title="Click to modify"
              @click="toggleModifyDate(data.item, 'endDate')"
              style="cursor: pointer"
              >{{ formatDate(data.item.endDate) }}</span
            >
          </template>
          <template #cell(notes)="data">
            <span v-b-popover.hover.top="data.item.comments.user">
              {{ summarize(data.item.comments.user || '') }}
            </span>
          </template>
          <template #cell(comment)="data">
            <b-link
              v-b-popover.hover.top="data.item.comments.manager"
              @click="toggleCommentModal(data.item)"
              :style="
                data.item.comments.manager ? 'color: #333' : 'color: #999'
              "
              title="Click to change">
              {{
                summarize(data.item.comments.manager || '') || 'Click to add'
              }}
            </b-link>
          </template>
          <template #cell(status)="data">
            <h5>
              <b-badge
                class="lizard-holiday-status"
                :variant="GetHolidayStatusVariant(data.item.status)"
                @click="UpdateHolidayStatus(data.item)">
                {{ data.item.status }}
              </b-badge>
            </h5></template
          ><template #cell(refCode)="data">
            <b-badge
              variant="info"
              v-if="data.item.refCode"
              style="cursor: default">
              {{ data.item.refCode }}
            </b-badge>
          </template></b-table
        >
        <b-pagination
          v-model="pager.currentPage"
          :total-rows="listItems.length"
          :per-page="pager.perPage"
          aria-controls="activityTable"
          size="sm"
          pills
          align="center"></b-pagination>
      </div>
    </div>
    <div class="row" v-if="!listItems.length">
      <div class="col-sm-5"></div>
      <div class="col-sm-2">
        <b-badge variant="secondary"
          >There isn't any records to show here!</b-badge
        >
      </div>
      <div class="col-sm-5"></div>
    </div>
    <b-modal
      v-model="allowanceModal.show"
      centered
      scrollable
      button-size="sm"
      size="xl"
      modal-class="lz-activity-modal lz-controls"
      content-class="lz-modal-content"
      body-class="lz-modal-body"
      :title="allowanceModal.data.title"
      :header-bg-variant="allowanceModal.headerBgVariant"
      :header-text-variant="allowanceModal.headerTextVariant"
      :body-bg-variant="allowanceModal.bodyBgVariant"
      :body-text-variant="allowanceModal.bodyTextVariant"
      :footer-bg-variant="allowanceModal.footerBgVariant"
      :footer-text-variant="allowanceModal.footerTextVariant">
      <HolidayStatsBox :statsData="allowanceModal.data" />
      <template #modal-footer>
        <b-button
          size="sm"
          variant="outline-secondary"
          class="lz-close-btn"
          @click="allowanceModal.show = false">
          Close
        </b-button>
      </template>
    </b-modal>
    <b-modal
      v-b-modal.modal-footer-sm
      v-model="commentModal.show"
      centered
      :title="commentModal.data.title"
      :header-bg-variant="commentModal.headerBgVariant"
      :header-text-variant="commentModal.headerTextVariant"
      :body-bg-variant="commentModal.bodyBgVariant"
      :body-text-variant="commentModal.bodyTextVariant"
      :footer-bg-variant="commentModal.footerBgVariant"
      :footer-text-variant="commentModal.footerTextVariant">
      <b-container fluid>
        <b-row class="mb-1">
          <b-col>
            <b-textarea
              trim
              no-resize
              rows="4"
              v-model="commentModal.data.commentData.comment"
              placeholder="add your comment..."></b-textarea>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="info"
            size="sm"
            class="float-right"
            @click="submitComment">
            Submit
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-overlay no-wrap :show="updateInProgress">
      <template #overlay>
        <div
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="p-3">
          <h3><strong style="color: #999">Change confirmation</strong></h3>
          <hr />
          <div class="d-flex text-left">
            {{ popupMsg }}
          </div>
          <hr />
          <div class="d-flex text-right">
            <b-button
              variant="secondary"
              @click="onCancel"
              style="margin-right: 3px !important">
              Cancel
            </b-button>
            <b-button variant="info" @click="onConfirm"> Confirm </b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <MandatoryLeaveModal
      v-model="showMandatoryLeaveModal"
      :can-apply="canApplyMandatoryLeave" />
  </b-container>
</template>

<script>
import ServicesOld from '../../services/index.vue'
import Services from '../../services/main.service.vue'
import {
  format as dateFormat,
  subDays,
  isWeekend,
  differenceInBusinessDays,
  differenceInQuarters
} from 'date-fns'
import HolidayStatsBox from './holiday-components/Stats.vue'
import FitersBar from './holiday-components/Filters.vue'
import MandatoryLeaveModal from './holiday-components/MandatoryLeaveModal.vue'

export default {
  name: 'HolidayDashboard',
  components: {
    FitersBar,
    HolidayStatsBox,
    MandatoryLeaveModal
  },
  data() {
    return {
      q: null,
      pager: {
        perPage: 25,
        currentPage: 1
      },
      bankHolidays: [],
      showMandatoryLeaveModal: false,
      listFields: [
        { key: 'submitted', label: 'Submitted date', sortable: true },
        // { key: 'refCode', label: 'Reference Code' },
        { key: 'fullname', label: 'Person name', sortable: true },
        { key: 'type', label: 'Type', sortable: true },
        { key: 'startDate', label: 'From', sortable: true },
        { key: 'endDate', label: 'To', sortable: true },
        { key: 'totalDays', label: 'Days requested', sortable: true },
        { key: 'notes', label: 'Notes' },
        { key: 'comment', label: 'Manager comment' },
        { key: 'status', label: 'Status', sortable: true }
      ],
      listItems: [],
      clonedItems: [],
      holidayStatusOpts: [],
      allowanceModal: {
        show: false,
        // Same chrome as the "New Holiday" dialog in holiday-components/
        // Create.vue: white header/body/footer, with the rounding, shadow and
        // padding coming from .lz-activity-modal in src/styles/logs.css.
        headerBgVariant: 'white',
        headerTextVariant: 'dark',
        bodyBgVariant: 'white',
        bodyTextVariant: 'dark',
        footerBgVariant: 'white',
        footerTextVariant: 'dark',
        data: {
          loading: true,
          title: 'Please wait...',
          years: [],
          allowance: {}
        }
      },
      commentModal: {
        show: false,
        headerBgVariant: 'info',
        headerTextVariant: 'light',
        bodyBgVariant: 'light',
        bodyTextVariant: 'dark',
        footerBgVariant: 'light',
        footerTextVariant: 'dark',
        data: {
          loading: true,
          commentData: {
            uid: null,
            comment: ''
          }
        }
      },
      holidayStatusDics: ['pending', 'approved', 'rejected'],
      metas: {},
      popupMsg: '',
      datesOnEdit: {},
      typeOnEdit: {},
      updateInProgress: false,
      updateQueue: []
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    reportsFilters() {
      return this.Store.leavesFilters
    },
    canApplyMandatoryLeave() {
      return this.Store.userAuth?.hasSuperAdminPrivileges ?? false
    },
    datePickerOptions() {
      return {
        firstDayOfWeek: 1,
        disabledDate: (dt) => {
          const isBankHoliday = this.bankHolidays.includes(
            dateFormat(new Date(dt), 'yyyy-MM-dd')
          )
          const dtYear = new Date(dt).getFullYear()
          const now = new Date()
          const currentYear = now.getFullYear()
          const sideYear =
            currentYear +
            (!Math.abs(
              differenceInQuarters(
                now,
                new Date(currentYear + 1, 1, 1, 0, 0, 0, 0)
              )
            )
              ? 1
              : -1)
          const sameYear = [currentYear, sideYear].includes(dtYear)
          return isWeekend(new Date(dt)) || isBankHoliday || !sameYear
        }
      }
    }
  },
  mounted() {
    this.$root.$on('tab_holidays_selected', this.tabMounted)
    this.$root.$on('open-mandatory-leave-modal', () => {
      this.showMandatoryLeaveModal = true
    })
  },
  methods: {
    async tabMounted() {
      if (this.bankHolidays.length === 0) {
        const { status, data } = await this.getBankHolidays()
        if (status === 200) {
          this.bankHolidays = data.content.map((bh) => bh.date)
        }
      }
      if (!this.reportsFilters.dates?.length) {
        const date1 = new Date()
        date1.setDate(1)
        // date1.setMonth(date1.getMonth() - 1)
        date1.setHours(0, 0, 0, 0)
        const date2 = new Date()
        date2.setDate(1)
        date2.setMonth(date2.getMonth() + 2)
        date2.setHours(23, 59, 59, 999)
        this.reportsFilters.dates = [
          dateFormat(date1, 'yyyy-MM-dd'),
          dateFormat(subDays(date2, 1), 'yyyy-MM-dd')
        ]
      }
      this.q = null
      setTimeout(() => {
        this.clonedItems = []
        this.GetList()
      }, 500)
    },
    async getBankHolidays() {
      return await ServicesOld.GetBankHolidays()
    },
    async GetList() {
      this.listItems = []
      this.clonedItems = []
      await this.fetchMetas()
      // Filters
      const {
        user: { uid: userUid },
        dateLabel: datesType,
        dates
      } = this.reportsFilters
      const response = await ServicesOld.GetHolidayList({
        userUid,
        datesType,
        dates
      })
      this.listItems = response.data.content.map((item) => {
        this.datesOnEdit[item.uid] = []
        this.typeOnEdit[item.uid] = false
        if (item.type.toLowerCase() === 'half-day' && item.meridiem) {
          item.type = item.type + ' (' + item.meridiem.toUpperCase() + ')'
        }
        item.submitted = item.submitted ? new Date(item.submitted) : null
        item.startDate = item.startDate ? item.startDate : null
        item.endDate = item.endDate ? new Date(item.endDate) : null
        item.status = item.status.toUpperCase()
        item.datesOnEdit = this.datesOnEdit[item.uid]
        item.typeOnEdit = this.typeOnEdit[item.uid]
        item.holidayTypes = []
        return item
      })
      this.clonedItems = [...this.listItems]
    },
    async GetHolidayAllowencesByUser({ uid }) {
      const response = await ServicesOld.GetHolidayAllowencesByUser(uid)
      return response?.data?.content ?? {}
    },
    async fetchMetas() {
      const { status, data } = await Services.Projects.Admin.getMetas()
      if (status === 200) {
        const {
          holidays: { status: holidaysList }
        } = data.content.metas
        this.holidayStatusOpts = holidaysList
      }
    },
    showLeaveStats(owner) {
      this.allowanceModal.data.loading = true
      this.allowanceModal.data.title = `${owner.firstName}'s allowances`
      this.allowanceModal.data.years = []
      this.GetHolidayAllowencesByUser(owner)
        .then((data) => {
          this.allowanceModal.show = true
          this.allowanceModal.data.loading = false
          this.allowanceModal.data.years = Object.keys(data)
          this.allowanceModal.data.user = owner.uid
          this.allowanceModal.data.allowance = data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    GetHolidayStatusVariant(status) {
      let variant = 'light'
      switch (status.toLowerCase()) {
        case 'approved':
          variant = 'success'
          break
        case 'rejected':
          variant = 'danger'
          break
        case 'pending':
          variant = 'warning'
          break
        case 'failed':
          variant = 'dark'
          break
      }
      return variant
    },
    toggleModifyDate(item, type) {
      const datesOnEdit = this.datesOnEdit[item.uid] || []
      if (datesOnEdit.includes(type)) {
        datesOnEdit.splice(datesOnEdit.indexOf(type), 1)
        // check if the leave type was HALF-DAY
        if (item.totalDays === 0.5) {
          item[type === 'startDate' ? 'endDate' : 'startDate'] = item[type]
        }
        // recalculate total days
        const totalDays =
          item.totalDays === 0.5
            ? 0.5
            : differenceInBusinessDays(
                new Date(item.endDate),
                new Date(item.startDate)
              ) + 1
        if (totalDays > 0) {
          item.totalDays = totalDays
          this.updateInProgress = true
          const queuedItem = this.updateQueue.find(
            (itm) => itm.uid === item.uid
          )
          const hType = type === 'startDate' ? 'start' : 'end'
          this.popupMsg = `
            You are going to change ${queuedItem.owner.firstName} ${
            queuedItem.owner.lastName
          }'s leave request ${hType} date from ${this.formatDate(
            queuedItem[type]
          )} to ${this.formatDate(item[type])}.
            The total number of days for this request after the change will be ${totalDays} day${
            totalDays > 1 ? 's' : ''
          }.
          `
        } else {
          this.onCancel()
        }
      } else {
        this.popupMsg = ''
        if (this.updateQueue.findIndex((itm) => itm.uid === item.uid) === -1) {
          const clonedItem = Object.assign({}, item)
          this.updateQueue.push(clonedItem)
        }
        datesOnEdit.push(type)
      }
      this.datesOnEdit[item.uid] = datesOnEdit
    },
    async UpdateHolidayStatus({ uid, status }) {
      const itemIndex = this.list.findIndex((item) => item.uid === uid)
      try {
        // this.list[itemIndex].status = 'please wait...'
        const response = await ServicesOld.UpdateHoliday(uid, { status })
        if (response.data.status) {
          // // change item status
          this.list[itemIndex].status =
            this.holidayStatusDics[
              this.holidayStatusDics.indexOf(status.toLowerCase()) + 1
            ]?.toUpperCase() ?? this.holidayStatusDics[0]?.toUpperCase()
          // this.GetList()
        } else {
          this.list[itemIndex].status = 'failed'
          this.$bvToast.toast('Please try again later', {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
          setTimeout(() => {
            this.list[itemIndex].status = status
          }, 500)
        }
      } catch (error) {
        error = error?.response?.data?.error?.details?.validationErrors ?? [
          error?.message ?? ''
        ]
        if (error.length) {
          this.list[itemIndex].status = 'failed'
          this.$bvToast.toast(error, {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
          setTimeout(() => {
            this.list[itemIndex].status = status
          }, 500)
        } else {
          console.error({ error })
        }
      }
    },
    toggleCommentModal(itm) {
      this.commentModal.data.loading = true
      this.commentModal.data.commentData = {}
      if (!this.commentModal.show) {
        this.commentModal.data.title = 'Loading...'
        this.commentModal.data.commentData = {
          uid: itm.uid,
          comment: itm.comments?.manager ?? ''
        }
        this.commentModal.data.title = `Comment for ${itm.owner.firstName}'s request`
      } else {
        this.commentModal.data.title = 'Default'
      }
      this.commentModal.data.loading = false
      this.commentModal.show = !this.commentModal.show
    },
    async submitComment() {
      const { uid, comment } = this.commentModal.data.commentData
      const itemIndex = this.listItems.findIndex((item) => item.uid === uid)
      const response = await ServicesOld.UpdateHoliday(uid, { comment })
      if (response.data.status) {
        // change item status
        this.listItems[itemIndex].comments.manager = comment
      } else {
        this.$bvToast.toast('Please try again later', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
        setTimeout(() => {
          this.listItems[itemIndex].comments.manager = null
        }, 500)
      }
      this.toggleCommentModal()
    },
    async UpdateAllowance() {
      const now = new Date()
      const { allowancesData, uid } = this.allowancesModal.data
      let leaveAllowances = {}
      leaveAllowances[now.getFullYear()] = allowancesData.reduce((acc, itm) => {
        for (const group in itm.groups) {
          acc[group] = Number(itm.groups[group])
        }
        return acc
      }, {})
      await Services.Users.Admin.updateUser({
        uid,
        data: {
          leaveAllowances
        }
      })
      this.allowancesModal.data.allowancesData =
        await this.GetHolidayAllowencesByUser({ uid })
    },
    async getHolidayTypeList(item) {
      const currentYear = new Date().getFullYear()
      const allowances = await this.GetHolidayAllowencesByUser({
        uid: item.owner.uid
      })
      // Export Holiday Types based on Remaining Allowance
      const typeDic = {
        CARRYFORWARD: 'Carry Forward',
        INLIEU: 'In-Lieu',
        HALFPERSONAL: 'Half Personal'
      }
      const years = {}
      for (const year in allowances) {
        years[year] = years[year] || {}
        allowances[year].forEach((itm) => {
          for (const group in itm.groups) {
            years[year][group] = {
              value: group,
              text: typeDic[group] ?? itm.value,
              _allowance: itm.groups[group],
              _remains: itm.groups[group] ? itm.remains : 0
            }
            if (group === 'ANNUAL') {
              years[year]['HALFDAYAM'] = {
                value: 'HALFDAYAM',
                text: 'Half Day (AM)',
                _allowance: itm.groups[group],
                _remains: itm.groups[group] ? itm.remains : 0
              }
              years[year]['HALFDAYPM'] = {
                value: 'HALFDAYPM',
                text: 'Half Day (PM)',
                _allowance: itm.groups[group],
                _remains: itm.groups[group] ? itm.remains : 0
              }
            }
          }
        })
      }
      for (const year in years) {
        years[year] = Object.values(years[year]).sort((a, b) => {
          if (a.text < b.text) return -1
          if (a.text > b.text) return 1
          return 0
        })
      }
      item.holidayTypes = years[currentYear]
      item.type =
        item.holidayTypes.find((type) => type.text === item.type)?.value ??
        item.type
      item.typeOnEdit = true
    },
    changeHolidayType(item) {
      const toUpdate = {
        type: item.type
      }
      const oneDayLeavePeriodType = /^(?<hPerfix>half|birth).+/i.exec(item.type)
      if (oneDayLeavePeriodType) {
        item.totalDays =
          oneDayLeavePeriodType?.groups?.hPerfix?.toLowerCase() === 'birth'
            ? 1
            : 0.5
        item.endDate = item.startDate
        toUpdate.totalDays = item.totalDays
        toUpdate.startDate = item.startDate
        toUpdate.endDate = item.endDate
      }
      ServicesOld.UpdateHoliday(item.uid, toUpdate)
        .then(() => {
          item.type =
            item.holidayTypes.find((type) => type.value === item.type)?.text ??
            item.type
          item.typeOnEdit = false
        })
        .catch(() => {
          this.$bvToast.toast('Failed to update holiday type.', {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        })
    },
    onCancel() {
      this.popupMsg = ''
      this.updateInProgress = false
      const itemIndex = this.listItems.findIndex(
        (itm) => itm.uid === this.updateQueue[0].uid
      )
      this.listItems[itemIndex].startDate = this.updateQueue[0].startDate
      this.listItems[itemIndex].endDate = this.updateQueue[0].endDate
      this.listItems[itemIndex].totalDays = this.updateQueue[0].totalDays
      this.updateQueue = []
    },
    onConfirm() {
      this.popupMsg = ''
      this.updateInProgress = false
      const itemIndex = this.listItems.findIndex(
        (itm) => itm.uid === this.updateQueue[0].uid
      )
      const item = Object.assign({}, this.listItems[itemIndex])
      item.totalDays =
        differenceInBusinessDays(
          new Date(item.endDate),
          new Date(item.startDate)
        ) + 1
      const oneDayLeavePeriodType = /^(?<hPerfix>half|birth).+/i.exec(item.type)
      if (oneDayLeavePeriodType) {
        const totalDays =
          oneDayLeavePeriodType?.groups?.hPerfix?.toLowerCase() === 'birth'
            ? 1
            : 0.5
        if (item.totalDays > 1) {
          // revert changes
          this.listItems[itemIndex].totalDays = this.updateQueue[0].totalDays
          this.listItems[itemIndex].startDate = this.updateQueue[0].startDate
          this.listItems[itemIndex].endDate = this.updateQueue[0].endDate
          // error
          this.$bvToast.toast(
            'The total number of days does not align with the maximum allowance for this leave request type.',
            {
              title: 'Error',
              variant: 'danger',
              solid: true
            }
          )
          this.updateQueue = []
          return
        }
        item.totalDays = totalDays
      }

      ServicesOld.UpdateHoliday(item.uid, {
        totalDays: item.totalDays,
        startDate: item.startDate,
        endDate: item.endDate
      })
      this.updateQueue = []
    },
    formatDate(date) {
      return dateFormat(new Date(date), 'dd/MM/yyyy')
    },
    summarize(note) {
      note = note.trim()
      if (note.length > 20) {
        return note.substring(0, 20) + '...'
      } else {
        return note
      }
    }
  },
  watch: {
    q: {
      handler(q) {
        if (q && q.trim().length > 1) {
          const keywords = q
            .trim()
            .split(' ')
            .map((keyword) => keyword.trim())
          this.listItems = this.clonedItems.filter((itm) => {
            const fullName = `${itm?.owner?.firstName?.trim() ?? ''} ${
              itm?.owner?.lastName?.trim() ?? ''
            }`
            const ownerEmail = itm?.owner?.email?.trim()?.split('@')?.[0] ?? ''
            const refCode = itm?.refCode?.trim() ?? ''
            return keywords.every((keyword) => {
              const qRegEx = new RegExp(keyword, 'i')
              return (
                qRegEx.test(fullName) ||
                qRegEx.test(ownerEmail) ||
                qRegEx.test(refCode)
              )
            })
          })
        } else {
          this.listItems = this.clonedItems
        }
      },
      deep: true
    },
    listItems: {
      handler() {
        this.list = this.listItems
      },
      deep: true
    },
    reportsFilters: {
      handler() {
        this.GetList()
      },
      deep: true
    }
  }
}
</script>

<style>
.cost-details-btn {
  font-size: 9pt !important;
  font-weight: bold;
  color: #6cf;
}
.lizard-column-fees {
  font-family: 'Courier New', Courier, monospace !important;
  font-size: 12px !important;
  font-weight: 100 !important;
}
.lizard-column-fees-disabled {
  color: #999;
}
</style>

<style scoped>
.allowence-table-header {
  font-size: 12px !important;
  font-weight: bold !important;
  color: #999 !important;
  text-align: center;
}
.allowence-data-row {
  font-size: 12px !important;
  font-weight: bold !important;
  color: #666 !important;
  text-align: center;
  min-height: 40px;
  line-height: 40px;
}
.allowence-data-row .allowence-input {
  border: 0;
  background: transparent;
  font-size: 12px !important;
  font-weight: bold !important;
  color: #666 !important;
  min-height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 0;
  padding: 0;
}
.allowence-data-row:hover {
  background-color: rgba(102, 204, 255, 0.1);
}

.lizard-holiday-status {
  font-variant: small-caps;
  font-weight: bolder;
  font-size: 10pt !important;
  letter-spacing: 0.03em;
  padding: 4px 8px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.lizard-holiday-status:hover {
  cursor: pointer;
}
.lizard-activity-list {
  font-size: 12px !important;
  color: #666;
  font-weight: bold !important;
}
.lizard-column-index {
  text-align: center !important;
}
.lizard-form-empty-col {
  min-height: 20px !important;
}
.lizard-reports-stats li {
  display: inline-block;
}
.lizard-hourly-rate-input {
  text-align: center;
  width: 60px;
  max-width: 60px;
}
.lizard-date-input {
  text-align: center;
  width: 90px;
  max-width: 90px;
}
.header-msg {
  color: #666;
  font-weight: bold !important;
}
label {
  color: #666;
  line-height: 40px !important;
  font-weight: bold !important;
  font-size: 12px !important;
}
.txt {
  color: #666;
  font-weight: bold !important;
  font-size: 12px !important;
}
</style>

<style scoped>
.holiday-type-select {
  font-size: 0.9rem !important;
  color: #999 !important;
  font-weight: 500 !important;
}
</style>
